import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { usersApi } from "../../api/usersApi";
import { getErrorMessage } from "../../utils/getErrorMessage";

export default function UserCreate() {
  const nav = useNavigate();
  const [saving, setSaving] = useState(false);

  const [form, setForm] = useState({
    username: "",
    email: "",
    password: "",
    role: "user",
  });

  const onChange = (k) => (e) =>
    setForm((p) => ({ ...p, [k]: e.target.value }));

  const submit = async (e) => {
    e.preventDefault();
    setSaving(true);
    try {
      await usersApi.create({
        username: form.username.trim(),
        email: form.email.trim(),
        password: form.password,
        role: form.role,
      });
      nav("/users");
    } catch (err) {
      alert(getErrorMessage(err)); // ✅ artıq [object Object] çıxmayacaq
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ padding: 16, maxWidth: 640 }}>
      <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
        <h1 style={{ margin: 0 }}>Create User</h1>
        <button className="btn ghost" onClick={() => nav("/users")} disabled={saving}>
          Back
        </button>
      </div>

      <form
        onSubmit={submit}
        className="card"
        style={{ marginTop: 12, padding: 16, display: "grid", gap: 12 }}
      >
        <label>
          Username
          <input
            className="input"
            value={form.username}
            onChange={onChange("username")}
            required
          />
        </label>

        <label>
          Email
          <input
            className="input"
            type="email"
            value={form.email}
            onChange={onChange("email")}
            required
          />
        </label>

        <label>
          Password
          <input
            className="input"
            type="password"
            value={form.password}
            onChange={onChange("password")}
            required
          />
        </label>

        <label>
          Role
          <select className="input" value={form.role} onChange={onChange("role")}>
            <option value="user">user</option>
            <option value="admin">admin</option>
            <option value="superadmin">superadmin</option>
          </select>
        </label>

        <div style={{ display: "flex", gap: 8 }}>
          <button className="btn" disabled={saving}>
            {saving ? "Saving..." : "Create"}
          </button>

          <button
            type="button"
            className="btn ghost"
            onClick={() => nav("/users")}
            disabled={saving}
          >
            Cancel
          </button>
        </div>
      </form>
    </div>
  );
}
